import { Fragment } from 'react'
import logo from "../logo.svg"
// import { ConnectButton, ConnectDialog, Connect2ICProvider, useConnect } from "@connect2ic/react"
//import PlugConnect from '@psychedelic/plug-connect';
import { Link } from 'react-router-dom';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { ViewListIcon } from '@heroicons/react/outline';

// function classNames(...classes) {
//     return classes.filter(Boolean).join(' ')
// }

export default function NavBar() {

    // const { isConnected, principal, activeProvider } = useConnect({
    //     onConnect: () => {
    //       // Signed in
    //     },
    //     onDisconnect: () => {
    //       // Signed out
    //     }
    // })

    return (
        <Disclosure as="nav" className="bg-background">
            {({ open }) => (
                <>
                    <div className="mx-auto px-2 sm:px-4 lg:px-8">
                        <div className="relative flex h-16 items-center justify-between">
                            <div className="flex items-center px-2 lg:px-0">
                                <Link
                                    to="/"
                                    onClick={() => {
                                        window.scroll(0, 0);
                                    }}
                                >
                                    <div className="flex-shrink-0">
                                        <img
                                            className="h-auto w-auto"
                                            src={logo}
                                            alt="logo"
                                        />
                                    </div>
                                </Link>
                                <div className='flex-shrink-0 text-white'>(beta version)</div>
                            </div>
                            <div className="flex flex-1 justify-center px-2 lg:ml-6 lg:justify-end">
                                <div className="hidden lg:ml-6 lg:block">
                                    <div className="flex space-x-4">
                                        <Link
                                            to="/"
                                            className='rounded-md px-3 py-2 text-sm text-white hover:text-blue'
                                            onClick={() => {
                                                window.scroll(0, 0);
                                            }}

                                        >

                                            Tickets

                                        </Link>
                                        <Link
                                            to="/marketplace"
                                            className='rounded-md px-3 py-2 text-sm text-white hover:text-blue'
                                            onClick={() => {
                                                window.scroll(0, 0);
                                            }}

                                        >

                                            Marketplace

                                        </Link>
                                        <Link
                                            to="/about"
                                            className='rounded-md px-3 py-2 text-sm text-white hover:text-blue'
                                            onClick={() => {
                                                window.scroll(0, 0);
                                            }}

                                        >

                                            About Us

                                        </Link>

                                        <Menu as="div" className="relative ml-4 flex-shrink-0">
                                            <div>
                                                <Menu.Button className="relative pt-2 flex rounded-full bg-gray-800 text-sm text-white hover:text-blue">
                                                    Login
                                                </Menu.Button>
                                            </div>
                                            <Transition
                                                as={Fragment}
                                                enter="transition ease-out duration-100"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100"
                                                leaveTo="transform opacity-0 scale-95"
                                            >
                                                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-background py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                    <Menu.Item>
                                                         {/* <PlugConnect
                                                            dark
                                                            whitelist={['canister-id']}
                                                            onConnectCallback={
                                                                () => console.log(window.ic.plug.agent.getPrincipal())
                                                            }
                                                        />  */}
                                                    </Menu.Item>

                                                </Menu.Items>
                                            </Transition>
                                        </Menu>
                                    </div>
                                </div>
                            </div>
                            <div className="-mr-2 flex sm:hidden">
                                {/* Mobile menu button */}
                                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-gray-700 hover:text-white">
                                    <span className="absolute -inset-0.5" />
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <ViewListIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <ViewListIcon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>

                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden">
                        <div className="space-y-1 px-2 pb-3 pt-2">
                            {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}

                            <div className='grid grid-col-1'>
                                <Link
                                    to="/"
                                    className='rounded-md px-3 py-2 text-sm text-white hover:text-blue'
                                    onClick={() => {
                                        window.scroll(0, 0);
                                    }}

                                >

                                    Tickets

                                </Link>
                                <Link
                                    to="/marketplace"
                                    className='rounded-md px-3 py-2 text-sm text-white hover:text-blue'
                                    onClick={() => {
                                        window.scroll(0, 0);
                                    }}

                                >

                                    Marketplace

                                </Link>
                                <Link
                                    to="/about"
                                    className='rounded-md px-3 py-2 text-sm text-white hover:text-blue'
                                    onClick={() => {
                                        window.scroll(0, 0);
                                    }}

                                >

                                    About Us

                                </Link>

                                <Menu as="div" className="relative ml-4 flex-shrink-0">
                                    <div>
                                        <Menu.Button className="relative pt-2 flex rounded-full bg-gray-800 text-sm text-white hover:text-blue">
                                            Login
                                        </Menu.Button>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-background py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <Menu.Item>
                                                {/* <PlugConnect
                                                            dark
                                                            whitelist={['canister-id']}
                                                            onConnectCallback={
                                                                () => console.log(window.ic.plug.agent.getPrincipal())
                                                            }
                                                        />  */}
                                            </Menu.Item>

                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                            </div>
                        </div>
                    </Disclosure.Panel>
                </>

            )}
        </Disclosure>

    )
}